import intl from 'react-intl-universal';

export const CARD_STATE_MAP = {
  0: intl.get('app_enum_amount_status_normal'),
  1: intl.get('cpm_cards_should_update'),
  2: intl.get('config_constant_coupon_status_4'),
};

export const CARD_TYPE_MAP = {
  blank: 'F', // 空白卡
  guest: '6', // 宾客卡
  auth: '0', // 授权卡
};

export const CARD_ERROR_MAP = {
  noCard: 4,
};

// 门锁供应商品牌
export enum LockVendor {
  H21 = 'H21',
  BD = 'BIDA',
  YG = 'YANGGE',
  CHUANGJIA = 'CHUANGJIA',
  PengZe = 'PengZe',
  BE_LINE = 'BE_LINE',
}

export const LockVendorMap = {
  [LockVendor.BE_LINE]: '0',
};
